import { gql } from '@apollo/client';

export const getOwnUserDataQuery = gql`
  query getOwnUserData($userId: ID!) {
    user(where: { id: $userId }) {
      ...AuthenticatedItemFields
    }
  }
`;
